import { deepComparison } from "client/Misc/compareUtils";

export function checkHasFilter<TModel>(
	currentFilters: TModel,
	defaultFilters: TModel
): boolean {
	return !deepComparison(currentFilters, defaultFilters);
}